import { render, staticRenderFns } from "./transfer-order-list.vue?vue&type=template&id=02dd86bd&scoped=true&"
import script from "./transfer-order-list.vue?vue&type=script&lang=js&"
export * from "./transfer-order-list.vue?vue&type=script&lang=js&"
import style0 from "./transfer-order-list.vue?vue&type=style&index=0&id=02dd86bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd86bd",
  null
  
)

export default component.exports